module.exports = __webpack_public_path__ + "img/dairy-products-color.64649e23.png";